import { registerTracerListener, TraceLevel } from 'owa-trace';

export default function initializeTracer() {
    registerTracerListener(function(trace: string, level: TraceLevel) {
        /* tslint:disable:no-console */
        switch (level) {
            case TraceLevel.Warning:
                console.warn(trace);
                break;
            case TraceLevel.Error:
                console.error(trace);
                break;
            case TraceLevel.Info:
                console.log(trace);
                break;
        }
        /* tslint:enable:no-console */
    });
}
